"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExternalEventCardHeader = exports.ExternalEventCardBody = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _momentTimezone = babelHelpers.interopRequireDefault(require("moment-timezone"));

var _decorators = require("decorators");

var _AutomountingComponent = require("AutomountingComponent");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _temp;

var ExternalEventCardBody =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ExternalEventCardBody, _Component);

  function ExternalEventCardBody() {
    babelHelpers.classCallCheck(this, ExternalEventCardBody);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ExternalEventCardBody).apply(this, arguments));
  }

  babelHelpers.createClass(ExternalEventCardBody, [{
    key: "render",
    value: function render() {
      var start = (0, _momentTimezone.default)(this.props.start).tz(this.props.timezone);
      var end = (0, _momentTimezone.default)(this.props.end).tz(this.props.timezone);
      var dtext, ttext;

      if (this.props.unconfirmedDate) {
        dtext = start.format('MMMM YYYY');
        ttext = '';
      } else {
        ttext = "Starts ".concat(start.format('h:mmA'), " (").concat(start.format('z'), ")");

        if ((0, _momentTimezone.default)(start).add(24, 'hour') > end) {
          dtext = start.format('dddd | MMMM DD, YYYY');
          if (start.format('HHmm') == end.format('HHmm')) ttext = start.format('h:mmA') + ' (' + start.format('z') + ')';else ttext = start.format('h:mmA') + ' - ' + end.format('h:mmA') + ' (' + start.format('z') + ')';
        } else if (start.format('YYYYMM') == end.format('YYYYMM')) {
          dtext = start.format('MMMM DD') + ' - ' + end.format('DD, YYYY');
        } else if (start.format('YYYY') == end.format('YYYY')) {
          dtext = start.format('MMMM DD') + ' - ' + end.format('MMMM DD, YYYY');
        } else {
          dtext = start.fomat('MMMM DD, YYYY') + ' - ' + end.format('MMMM DD, YYYY');
        }
      }

      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "date"
      }, dtext), _react.default.createElement("h3", null, this.props.title), !this.props.isAllDay && ttext && _react.default.createElement("div", {
        className: "time"
      }, ttext), this.props.person && _react.default.createElement("div", {
        className: "person"
      }, _react.default.createElement(_ProfileImageContainer.default, {
        className: "image",
        noImageClassName: "initials",
        photo: this.props.person.photo,
        name: this.props.person.fullName
      }), _react.default.createElement("p", null, _react.default.createElement("span", {
        className: "person-name bold"
      }, this.props.person.displayedName, this.props.person.icons && this.props.person.icons.length > 0 && _react.default.createElement("span", {
        className: "account-icon-list"
      }, this.props.person.icons.map(function (_ref) {
        var id = _ref.id,
            title = _ref.title,
            icon = _ref.icon;
        return _react.default.createElement("img", {
          className: "account-icon",
          src: icon,
          title: title,
          key: id
        });
      }))), this.props.person.title && _react.default.createElement("span", {
        className: "person-title"
      }, " | ".concat(this.props.person.title)), this.props.person.location && _react.default.createElement("span", {
        className: "person-location"
      }, " | ".concat(this.props.person.location)))), this.props.sponsor && _react.default.createElement("div", {
        className: "sponsor"
      }, this.props.sponsor.logo && _react.default.createElement("div", {
        className: "left logo",
        style: {
          backgroundImage: "url(".concat(this.props.sponsor.logo, ")")
        }
      }), _react.default.createElement("div", {
        className: "right"
      }, _react.default.createElement("p", {
        className: "subtext"
      }, this.props.sponsor.headline), _react.default.createElement("p", {
        className: "bold"
      }, this.props.sponsor.title))));
    }
  }]);
  return ExternalEventCardBody;
}(_react.Component);

exports.ExternalEventCardBody = ExternalEventCardBody;
ExternalEventCardBody.cardStart = Date.now();
ExternalEventCardBody.cardPosition = 0;

var ExternalEventCardHeader =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ExternalEventCardHeader, _Component2);

  function ExternalEventCardHeader() {
    babelHelpers.classCallCheck(this, ExternalEventCardHeader);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ExternalEventCardHeader).apply(this, arguments));
  }

  babelHelpers.createClass(ExternalEventCardHeader, [{
    key: "render",
    value: function render() {
      var start = (0, _momentTimezone.default)(this.props.start).tz(this.props.timezone);

      if (this.props.unconfirmedDate) {
        return _react.default.createElement("div", {
          "data-start": this.props.start,
          "data-end": this.props.end,
          className: "unconfirmed"
        }, _react.default.createElement("h2", null, "TBD"), _react.default.createElement("p", null, start.format('MMM')));
      }

      return _react.default.createElement("div", {
        "data-start": this.props.start,
        "data-end": this.props.end
      }, _react.default.createElement("h2", null, start.format('D')), _react.default.createElement("p", null, start.format('MMM')));
    }
  }]);
  return ExternalEventCardHeader;
}(_react.Component);

exports.ExternalEventCardHeader = ExternalEventCardHeader;
ExternalEventCardHeader.cardStart = Date.now();
ExternalEventCardHeader.cardPosition = 0;
var ExternalEventInfo = (_class = (_temp =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(ExternalEventInfo, _Component3);

  function ExternalEventInfo() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ExternalEventInfo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ExternalEventInfo)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.state = {
      now: Date.now()
    };
    return _this;
  }

  babelHelpers.createClass(ExternalEventInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.timerTick();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this._nextTick);
    }
  }, {
    key: "timerTick",
    value: function timerTick() {
      this.setState({
        now: Date.now()
      });
      var start = (0, _momentTimezone.default)(this.props.start),
          now = (0, _momentTimezone.default)();

      if (now < start) {
        // If the event hasn't started
        if (now.clone().add(7, 'day') < start) {
          // If the event is more than a week out, tick down at the hourly interval
          this._nextTick = setTimeout(this.timerTick, now.clone().add(1, 'hour').diff(now));
        } else if (now.clone().add(1, 'minute') < start) {
          // If the event is more than a minute out, tick down at minutes
          this._nextTick = setTimeout(this.timerTick, now.clone().add(1, 'minute').diff(now));
        } else {
          // Tick again at the event start
          this._nextTick = setTimeout(this.timerTick, start.diff(now));
        }
      } else {
        var end = (0, _momentTimezone.default)(this.props.end);

        if (end > now) {
          // If the event hasn't finished, tick at the end of the event
          this._nextTick = setTimeout(this.timerTick, end.diff(now));
        }
      }
    }
  }, {
    key: "timeUntil",
    value: function timeUntil(time) {
      var diff = time - this.state.now;
      if (diff < 0) return null;
      diff = Math.round(diff / 1000);
      var seconds = diff % 60;
      diff -= seconds;
      diff /= 60;
      var minutes = diff % 60;
      diff -= minutes;
      diff /= 60;
      var hours = diff % 24;
      diff -= hours;
      diff /= 24;
      var days = diff % 7;
      diff -= days;
      diff /= 7;
      var weeks = diff;

      if (this.props.isAllDay) {
        if (!days && !weeks) return [[1, 'day', 'days']];
        return [[weeks, 'week', 'weeks'], [days, 'day', 'days']].filter(function (v) {
          return v[0];
        });
      }

      if (weeks) return [[weeks, 'week', 'weeks'], [days, 'day', 'days'], [hours, 'hr.', 'hrs.']].filter(function (v) {
        return v[0];
      });
      if (days) return [[days, 'day', 'days'], [hours, 'hr.', 'hrs.'], [minutes, 'min.', 'min.']].filter(function (v) {
        return v[0];
      });
      if (hours) return [[hours, 'hr.', 'hrs.'], [minutes, 'min.', 'min.']];
      return [[minutes, 'min.', 'min.']];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          timezone = _this$props.timezone,
          start = _this$props.start,
          end = _this$props.end,
          isAllDay = _this$props.isAllDay,
          title = _this$props.title,
          unconfirmedDate = _this$props.unconfirmedDate;
      start = (0, _momentTimezone.default)(start).tz(timezone);
      end = (0, _momentTimezone.default)(end).tz(timezone);
      var timeToStart = this.timeUntil(start.valueOf());
      var timeToEnd = this.timeUntil(end.valueOf());
      return _react.default.createElement("div", null, unconfirmedDate ? _react.default.createElement("div", {
        className: "date-container center unconfirmed"
      }, _react.default.createElement("h2", null, "TBD"), _react.default.createElement("p", {
        className: "uppercase"
      }, start.format('MMM'))) : _react.default.createElement("div", {
        className: "date-container center"
      }, _react.default.createElement("h2", null, start.format('D')), _react.default.createElement("p", {
        className: "uppercase"
      }, start.format('MMM'))), _react.default.createElement("div", {
        className: "details"
      }, _react.default.createElement(DateInfo, {
        start: start,
        end: end,
        unconfirmedDate: unconfirmedDate
      }), _react.default.createElement("h1", null, title), !isAllDay && !unconfirmedDate && _react.default.createElement(TimeInfo, {
        start: start,
        end: end,
        timeToStart: timeToStart,
        timeToEnd: timeToEnd
      })));
    }
  }]);
  return ExternalEventInfo;
}(_react.Component), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "timerTick", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "timerTick"), _class.prototype)), _class);
exports.default = ExternalEventInfo;

var DateInfo = function DateInfo(_ref2) {
  var start = _ref2.start,
      end = _ref2.end,
      unconfirmedDate = _ref2.unconfirmedDate;
  var sf = start.format('YYYY/MM/DD'),
      ef = end.format('YYYY/MM/DD');

  if (unconfirmedDate) {
    return _react.default.createElement("h3", {
      className: "bold uppercase"
    }, _react.default.createElement("span", {
      className: "full-day"
    }, start.format('MMMM YYYY')));
  }

  if (sf == ef || (0, _momentTimezone.default)(start).add(24, 'hour') > end) {
    return _react.default.createElement("h3", {
      className: "bold uppercase"
    }, _react.default.createElement("span", {
      className: "day"
    }, start.format('dddd')), _react.default.createElement("span", {
      className: "full-day"
    }, start.format('MMMM D, YYYY')));
  } // 'YYYY/MM'.length == 7


  if (sf.substring(0, 7) == ef.substring(0, 7)) {
    return _react.default.createElement("h3", {
      className: "bold uppercase"
    }, _react.default.createElement("span", {
      className: "full-day"
    }, start.format('MMMM D'), ' - ', end.format('D, YYYY')));
  } // 'YYYY'.length == 4


  if (sf.substring(0, 4) == ef.substring(0, 4)) {
    return _react.default.createElement("h3", {
      className: "bold uppercase"
    }, _react.default.createElement("span", {
      className: "full-day"
    }, start.format('MMMM D')), _react.default.createElement("span", {
      className: "full-day"
    }, end.format('MMMM D, YYYY')));
  }

  return _react.default.createElement("h3", {
    className: "bold uppercase"
  }, _react.default.createElement("span", {
    className: "full-day"
  }, start.format('MMMM D, YYYY')), _react.default.createElement("span", {
    className: "full-day"
  }, end.format('MMMM D, YYYY')));
};

var TimeInfo = function TimeInfo(_ref3) {
  var start = _ref3.start,
      end = _ref3.end,
      timeToStart = _ref3.timeToStart,
      timeToEnd = _ref3.timeToEnd;

  if ((0, _momentTimezone.default)(start).add(24, 'hour') > end) {
    if (start.format("HH:mm") == end.format("HH:mm")) {
      return _react.default.createElement("h3", {
        className: "bold uppercase"
      }, start.format('h:mmA'), timeToStart && _react.default.createElement("span", {
        className: "status startingIn"
      }, "Starts in ", timeToStart.map(function (_ref4) {
        var _ref5 = babelHelpers.slicedToArray(_ref4, 3),
            count = _ref5[0],
            unit = _ref5[1],
            pluralUnit = _ref5[2];

        return _react.default.createElement("span", {
          key: unit
        }, count, " ", count == 1 ? unit : pluralUnit);
      })), !timeToStart && timeToEnd && _react.default.createElement("span", {
        className: "status inProgress"
      }, "This event is in progress now."), !timeToStart && !timeToEnd && _react.default.createElement("span", {
        className: "status ended"
      }, "This event has ended."));
    }

    return _react.default.createElement("h3", {
      className: "bold uppercase"
    }, start.format('h:mmA'), ' - ', end.format('h:mmA'), ' (', start.format('z'), ')', timeToStart && _react.default.createElement("span", {
      className: "status startingIn"
    }, "Starts in ", timeToStart.map(function (_ref6) {
      var _ref7 = babelHelpers.slicedToArray(_ref6, 3),
          count = _ref7[0],
          unit = _ref7[1],
          pluralUnit = _ref7[2];

      return _react.default.createElement("span", {
        key: unit
      }, count, " ", count == 1 ? unit : pluralUnit);
    })), !timeToStart && timeToEnd && _react.default.createElement("span", {
      className: "status inProgress"
    }, "This event is in progress now."), !timeToStart && !timeToEnd && _react.default.createElement("span", {
      className: "status ended"
    }, "This event has ended."));
  }

  return _react.default.createElement("h3", {
    className: "bold uppercase"
  }, 'Starts ', start.format('h:mmA (z)'), timeToStart && _react.default.createElement("span", {
    className: "status startingIn"
  }, "In ", timeToStart.map(function (_ref8) {
    var _ref9 = babelHelpers.slicedToArray(_ref8, 3),
        count = _ref9[0],
        unit = _ref9[1],
        pluralUnit = _ref9[2];

    return _react.default.createElement("span", {
      key: unit
    }, count, " ", count == 1 ? unit : pluralUnit);
  })), !timeToStart && timeToEnd && _react.default.createElement("span", {
    className: "status inProgress"
  }, "This event is in progress now."), !timeToStart && !timeToEnd && _react.default.createElement("span", {
    className: "status ended"
  }, "This event has ended."));
};